import { useCallback, useEffect, useState } from "react";
import { getCuentaCorrienteSoloPendientes } from "../service/cuentaCorrienteSoloPendientesService";

export function useCuentaCorrienteSoloPendientes(cliente) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!cliente) return;

    setLoading(true);
    setError(null);

    try {
      const res = await getCuentaCorrienteSoloPendientes(cliente);
      setData(res);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [cliente]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const refresh = useCallback(() => {
    // console.log("cliente recibido:", cliente);
    fetchData();
  }, [fetchData]);

  return {
    data,
    loading,
    error,
    refresh,
  };
}
